import { render, staticRenderFns } from "./jd-title.vue?vue&type=template&id=1b224b90&scoped=true"
import script from "./jd-title.vue?vue&type=script&lang=js"
export * from "./jd-title.vue?vue&type=script&lang=js"
import style0 from "./jd-title.vue?vue&type=style&index=0&id=1b224b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b224b90",
  null
  
)

export default component.exports